// App-wide constants
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_academy-flow-18/artifacts/4avqnmbp_logonew.png";
export const BRAND_NAME = "Blue Mountain Group";
